import React, { useEffect, useCallback, useState} from 'react';
import TransformationEditor from "components/sidebar/TransformationEditor.js";
import {connect} from 'react-redux';
import {
    NEEDS_VALUE,
    MARKOV,
    EVERY,
    PROBABILITY,
    THEN_OPTIONS,
    WHEN_OPTIONS
} from 'pattern/groups/transformations.js';

const TransformationTooltip = ({transformation, track}) => { 
    let {thenType, whenType} = transformation;
    let whenTypeOption = WHEN_OPTIONS.find(x => x.value === whenType);
    let whenValue = transformation.whenValue.get();
    let auxValue = transformation.auxValue.get();
    let thenTypeOption = THEN_OPTIONS.find(x => x.value === thenType);
    let thenValue = transformation.thenValue.get();
    return (
        <div className="transformation-tooltip">
          <div className="when-type">
            {whenTypeOption && whenTypeOption.label}
          </div>
          {whenType === MARKOV ?
           <div className="when-value">
             {auxValue}%
           </div> : 
           <div className="when-value">
             {whenValue} {transformation.whenType === EVERY ? "loops" :
                          transformation.whenType === PROBABILITY ? "%" : ""}
           </div>}
          <div className="arrow-right"/>
          <div className="then-type">
            {thenTypeOption && thenTypeOption.label}
          </div>
          <div className="then-value">
            {NEEDS_VALUE.includes(thenType) ? thenValue : ''}
          </div>
        </div>);
};

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TransformationTooltip);
